import {cloneDeep, isObject} from "lodash";
import isEmpty from "@/commons/isEmpty";

export default function cleanUpProducts(value) {
    value = cloneDeep(value)
    Object.keys(value).forEach(province => {
        if (Array.isArray(value[province])) {
            value[province] = value[province].reduce((acc, product) => {
                if (isObject(product) && !isEmpty(product.tariffa_codice) && !isEmpty(product.warranty_codice)) {
                    acc.push(product)
                }
                return acc
            }, [])
        } else {
            delete value[province]
        }
    })

    return value
}
